import { useIntl } from "react-intl";
import { useMemo } from "react";
import useTrashablePromises from "hooks/useTrashablePromises";
import useGlobalContext from "hooks/globalData";
import { Skus } from "services/KnowfullyAdminClient";
import SkuForm from "./SkuDetailsForm";
import { SkuFormProps } from "types/sku-related-types";
import { Mode } from "types/common-types";

type SkuDetailsCreateFormProps = Omit<SkuFormProps, "sku" | "onSkuUpdated"> & {
  productId?: string;
  onSkuCreated: (id: string) => void;
  onCancel: () => void;
};

const SkuDetailsCreateForm = ({
  productId,
  onSkuCreated,
  onCancel,
  onDirty,
  onClean,
  onProductIdChange,
}: SkuDetailsCreateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  // TODO: complete once the save method becomes available
  const onSubmit = async (values: any) => {
    var response = await registerPromise(skuService.saveSku(new Skus(values)));
    onSkuCreated(response.id);
    return response;
  };

  const initialSku = useMemo(() => ({ productId }), [productId]);

  return (
    <SkuForm
      sku={initialSku}
      onSubmit={onSubmit}
      submitLabel={t({ id: "skuFormCreateButton" })}
      onCancel={onCancel}
      onDirty={onDirty}
      onClean={onClean}
      mode={Mode.Create}
      onProductIdChange={onProductIdChange}
    />
  );
};

export default SkuDetailsCreateForm;
